<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 智者大師</h3>
        <p>智者大師相傳為釋迦牟尼佛乘願再來，隋陳時代，大師見臨海漁民捕魚殺生，大起慈悲，以襯施買臨海漁滬一所作放生池，兼為漁民講經說法，漁民聞法後率皆改行轉業，好生從善，並獻臨海江滬溪梁六十三所，達三四百餘里，全部作為放生池，是我國有史以來最早的大規模放生，所救活的物命數以億萬計，現在的西湖，就是大師當年所創的古放生池。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 永明延壽大師</h3>
        <p>永明大師相傳為阿彌陀佛慈悲示現，五代時大師為餘杭縣庫吏，常常因救急以庫錢買魚蝦等物命放生，後因監守自盜罪被判死刑，行刑前大師態度從容，面不改色，國王很奇怪便詢問他緣由，大師回答：「我因為放生，救活的生命數以千萬，趁此功德，正好往生西方極樂世界，怎能不歡喜呢？」國王敬重大師德行，便釋放了他，大師自此出家為僧，念佛修行，得道證果，後世遵為蓮宗六祖。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 寒山／拾得大師</h3>
        <p>（寒山大師相傳為文殊菩薩示現，拾得大師相傳為普賢菩薩示現。）</p>
        <p>寒山問拾得：放生可成佛否？答曰：諸佛無心，惟以愛物為心。人能救物之苦，即能成就諸佛心願矣。故一念慈悲，救一物命，是一念觀世音也。日日放生則慈悲日日增長，久久不息則念念流入觀世音大慈悲海矣。我心即是佛心，焉得不成佛乎！故知放生因緣，非小善之所能比。凡我同願，宜廣行勸勉，善令群生同歸悲化。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 誌公禪師</h3>
        <p>梁武帝問誌公禪師：「放生功德如何？」</p>
        <p>梁武帝問誌公禪師：「放生功德如何？」答曰：「放生功德，不可限量。經云：蠢動含靈，皆有佛性，只因迷妄因緣，遂使昇沈各別，以渠生死輪迴互為六親眷屬，改頭換面不復相識。若能發喜捨心，起慈悲念，贖命放生者，現世保病延生，未來當證菩提。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 放生頌（誌公禪師因果錄）</h3>
        <p>放生合天心 放生順佛令 放生觀音慈 放生普賢行</p>
        <p>放生無憂惱 放生少病疾 放生嗣胤昌 放生官祿盛</p>
        <p>放生免三災 放生家門慶 殺生與放生 果報明如鏡</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 遵氏大師（慈雲懺主）</h3>
        <p>遵氏大師晚年主持杭州昭慶、靈山等寺，講經弘法，宋真宗賜號「慈雲」，大師曾以天台智者大師放生的故事，告訴州判王欽若，並請他奏准以西湖為放生池，獲朝廷准許，下令西湖為放生池，禁止一切漁獲捕獵，重現智者大師時代放生風範！</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 佛印禪師（戒殺文）</h3>
        <p>貪他一臠臠還他　古聖留言終不偽</p>
        <p>戒殺念佛兼放生　決到西方上品會</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 真歇禪師（慶生報本戒殺文）</h3>
        <p>人之生日到來 應當持齋戒殺 或是買命放生 或是誦經念佛</p>
        <p>修橋砌路煮茶 隨意奉行善事 報答生身父母 乳哺三年大德</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 蓮池大師</h3>
        <p>「疾病之由，多從殺生中來，故偏重放生也。」
（徑中徑又徑精持門）

「戒殺之眾，善神守護，災橫消除，壽算綿長，子孫賢孝，吉祥種種，難可具陳。若更隨力放生，加持念佛，不但增崇福德，必當隨願往生，永脫輪迴，入不退地。」
（普勸戒殺放生文）

「世間至重者生命，天下最慘者殺傷」
「放生非獨佛教，儒中君子無不奉行。」
「諸放生者，或增福壽，或延壽算，
或免急難，或起沈痾，或生天堂，
或證道果，隨施獲報，皆有徵據。」
「普勸世人隨所見生命發慈悲心，是捐捨世財，作斯方便。」
「若無財者，只發慈悲心，亦是福德，或勸他人放生，或見人放生，讚嘆隨喜，增其善念，亦是福德。」
「放生不殺，與物無冤，非惟安樂今生，以此善根，當來之世，長壽永福，乃至成佛，萬類有情，傾心歸附。」
「心大德深，其事何驗，蓋利他者菩薩之行也，以此行門助修道業，譬如船得順風，必能速到涅槃彼岸矣。淨業三福，慈心不殺實居其一。今能不殺，又放其生，既能放生，又以法濟令生淨土，如是用心，報滿之時，九品蓮臺高步無疑。普勸世人，幸勿以我德薄人微。而不信其語也。」
（放生文）
「今更立簡易一法，佐使並行，不拘時日，見即買放。於某月下書某日放生若干，巨生以箇數計，細生以觔數計，歲終總算，存以自考。」
 （巨生如鴉雀龜鱉及大魚等，細生如蝦螺蛙蛤及小魚等，
積功累德，當知果報不可思議。） （放生圖說）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 放生頌</h3>
        <p>（書放生卷後）
人既重其生。物亦愛其命。放生合天心。放生順佛令。
放生怨結解。放生罪垢淨。放生免三災。放生離九橫。
放生壽命長。放生官祿盛。放生無憂惱。放生少疾病。
放生嗣胤昌。放生家門慶。放生觀音慈。放生普賢行。
放生悟無生。放生生死竟。放生與殺生。果報明如鏡。
（放生圖說）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 放生偈</h3>
        <p>上帝好生。下民傷生。
捨財救生。圖財捕生。
繇二念生。故有眾生。
生無所生。亦無能生。
無生不生。是名放生。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>憨山大師● 放生偈</h3>
        <p>人既愛其壽 生物愛其命 放生合天心 放生順佛令
放生免三災 放生離九橫 放生壽命長 放生官祿盛
放生子孫昌 放生家門慶 放生無憂惱 放生少疾病
放生解冤結 放生罪垢淨 放生觀音慈 放生普賢行
放生與殺生 果報明如鏡 放生又念佛 萬修萬人證</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●蕅益大師（靈峰宗論卷六之三）</h3>
        <p>「殺生即殺自心未來諸佛，放生即放自心未來諸佛，若放自心未來諸佛，即真念佛三昧，修此念佛三昧，是恒轉法華經百千萬億部也。」
「欲即人心證佛心，轉劫濁成淨土，術莫於放生，放生一法，唯廣與久，一杯水不救車薪火，唯設人各一杯焉，一杯不已再一杯已，杯水多，車火未有不滅者，今殺運紛紛，並同分惡業招感，非慈悲三昧水，熟能熄之。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 印光大師</h3>
        <p>「戒殺放生者，來世得生於四王天，享無極之福，若兼修淨土者，直可往生於西方極樂國土，其功德實無涯矣。」
（放生十大功德）

「凡有欲家門清泰，身心康寧，天下太平，人民安樂者，請皆于戒殺放生，喫素念佛中求之，則求無不得矣。」
（法雲寺放生池疏）

「佛教東來，闡明因果報應，令人戒殺放生，斷葷吃素。」
（挽回劫運論）

「余向提倡戒殺放生，因果報應等事理，以期挽救天災人禍。」
（勸愛惜物命說）

「人惟欲眷屬團聚，壽命延長，身心安樂，諸緣如意，正應發大悲心，行放生業，使天地鬼神，悉皆愍我愛物之誠，則向之所欲，當可即得。」
（江慎修先生放生殺生現報錄序）

「我今幸承宿世福善，生於人道，固宜解怨釋結，戒殺放生，令彼一切有生命者，各得其所。又為念佛回向淨土，令得度脫。」

「凡大聖大賢，無不以戒殺放生，為挽殺劫以培福果，息刀兵而樂天年之基址。」

「是知戒殺放生，乃拔本塞源之濟世良謨也。」

「須知放生一事，實為發起同人，普護物命之最勝善心。」
（南潯極樂寺重修放生池疏）

「放生一事，原為啟發現未人之善心，以期戒殺茹素，普令含識各得其所，各盡天年。近之則息殺因，遠之則滅殺果，小之則全吾心之純仁，大之則弭世界之殺劫。」
（常熟蓮華庵放生池碑記）

「天地之大德曰生，人民之大本曰善，生則植物動物並育，善則仁民愛物修行。乾為大父，坤為大母，民吾同胞，物吾與也。」
（靈巖山寺下院放生池附設放生會緣起碑記）

「常行放生，常行殺生，天地鬼神常為鑑臨，必當降以禍福，且勿忽其弱而欺之。」
（放生殺生現報錄戒殺放生各文合編序）

「聖君賢相，哲士鴻儒，多皆仰遵佛訓，俯培己仁，或茹素而斷葷，或戒殺而放生，其嘉言懿行，載諸史冊，亦企後人同修慈心，愍彼物類。」
（烏程周夢坡居士夫人誕期放生碑記）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 弘一大師</h3>
        <p>「先問諸君：一欲延壽否？二欲愈病否？三欲免難否？四欲得子否？倘願者，今有一最簡便易行之法奉告，即是放生也。」
「惟願諸君自今以後，力行放生之事，痛改殺生之事。」
（放生與殺生之果報）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 虛雲老和尚</h3>
        <p>「我們要勇猛精進，要內外加修。內修，即是單單的參一句「念佛是誰」的話頭，或念一句「阿彌陀佛」，不起貪瞋癡恚種種其他念頭，使真如法性得以透露。外修，即是戒殺放生，將十惡轉為十善，不要一天到晚酒肉薰天，造無邊的罪業。」「近來世界人民遭難，殺劫之重，皆是果報所遭；每每勸世人要戒殺放生，吃齋念佛者，也就是要大家免遭因果輪迴之報；諸位須當信奉，種植善因，成就佛果。」
（虛雲和尚方便開示）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 諦閑大師</h3>
        <p>「不殺為諸戒之首，而放生為眾善之先也。」
「歷朝以來，緇素通人，慈善大家，以放生為務者，典籍所載，未易僕罄也。」
「古聖先賢，莫不以仁慈濟物，博愛利生，是知凡為人者，要當以仁存心。」
「夫乾曰大生，坤曰廣生，生物不息，天地之大德，人秉天地之氣以生，當以天地好生之心為心。」
（諦閑大師語錄）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 圓瑛大師</h3>
        <p>「至論護生一事，佛儒二教，若合符節。我佛以大慈大悲而為救世之本，大慈者，與一切眾生之樂，大悲者，拔一切眾生之苦。」

「吾人當學佛之大慈大悲，實行戒殺放生，方是學佛之行。是以學佛者，不僅持律戒殺，尤當竭力放生，方合我佛慈悲宗旨。」

「儒教周易有言，乾曰大生，坤曰廣生，天地之大德曰生，故孔子讚易以生生。吾人應體天地好生之德，提倡戒殺放生。」

「出家以來，每年力行放生，本會乃以蓮池放生會為名，當以佛教慈悲，儒宗惻隱，而作護生運動，實為天下無上吉祥善事。」

「希望社會諸君，勉力行之，即遇壽辰、結婚、生子，是自己求生，慶生吉祥之事，均宜戒殺放生茹素，以善因而求善果也。」
（圓瑛法師講演錄）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 妙善大師（金山活佛）</h3>
        <p>「最好的消業方法，莫過於放生，世界上最大的惡業莫過於殺生害命，反過來說，世界上最大的善業是莫過於戒殺放生，所以放生是最大的功德。你能依我的話，趕快量力買生物放生，就能增福延壽的。」
（金山活佛　煮雲法師著）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 李炳南老居士</h3>
        <p>「放生是救他生命，解他痛苦，佛戒第一不殺，天有好生之德，可以想見功德之大，所得善報無量無邊。在二千八九百年時的中國與印度，未通消息，佛教在印，曾行放生，儒教在中亦曾放生，並非誰倡誰效，善道自然同耳，兩教放生之經典各有記載，多不勝舉，查書當知。」

「下功斷緣戒殺，中功斷緣兼素，上功斷緣放生。」

「上等功德，除了斷緣外，必須兼放生，佛家有一句話說：救一眾生，勝造七級浮屠。七級浮屠就是寺廟的七層寶塔，這樣看起來就知道救一個眾生的功德是多麼大。」

「一切眾生不但是過去父母，亦是未來諸佛，你放牠的性命你就是菩薩。」

「不單是佛教提倡戒殺放生，我們中國的古聖先賢，亦多說戒殺放生的道理。」

「戒殺放生，這是心性的問題，就是有慈悲，沒有慈悲的問題。」

「奉勸諸位，現在戰亂還未來臨，快快改往修來，快快戒殺放生。」
（李炳南老居士全集）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 懺公師父</h3>
        <p>「丙甲春雲臥病岡山，經久不癒，醫藥治療，營養滋補，靜攝調護，悉皆罔效，身心苦悶，不知所措。嗣承淨業道侶慈悲勸諭，謂若提倡放生，與眾行之當得早占勿藥云云。雲遂依勸告，先自放生，並同諸方提倡，經時不久，頑強痼疾霍然痊癒。」
（放生儀規）</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 圓因師父</h3>
        <p>「我們多今生累劫以來，所造所欠的殺債，可能也虛空也裝不下，而放生就是還債，還累劫多生以來，我們所欠無數的殺債。」

「我們要深信因果，放生自有放生的善報，殺生自有殺生的惡報，鼓勵讚嘆放生自有鼓勵讚嘆放生的善報，阻撓批評放生自有阻撓批評放生的惡報，種什麼因，就得什麼果，因因果果是絕對錯不了的。」

「疾病癌症，災難不幸之所以會發生，就是緣於我們以前所造的殺業感召而來的業報。解決之道就是放生，藉著出錢出力贖命放生，來償還以前我們所欠無數的殺債。」

「每一個眾生最寶貴的是自己的生命，殺了他，他最惱恨，冤仇結得最深，所以說殺業最重，每一個眾生最珍貴的還是自己的生命，救了他，他最感激，福善積得最深，所以說放生第一。」

「放生就是救急，與其他的功德不一樣，放生是救性命垂危，朝不保夕的受困受難的眾生，我們一放生，當下眾生就免除死難，重拾生機，我們不放生，眾生就只有受宰待殺的唯一死路了，放生是救急救命的行為，所以功德至大，非其他小善所能比擬！」

「放生最重要的是皈依以及念佛。「皈依佛，不墮地獄。皈依法，不墮餓鬼。皈依僧，不墮畜生。」物命在經過三皈依儀式後，承佛法僧三寶加持，畜生報盡，不再淪入三惡道中，得以轉世超生，並且物命親聞「南無阿彌陀佛」聖號。六字洪名盈盈入耳，既植道種，他日因緣成熟，必能值遇佛法，念佛修行，往生西方極樂世界，永斷六道生死輪迴，此乃放生中之大放生，是放生中最重要的意義。」

「放生最容易消業障，因為不限時間、不限地點、人多人少、錢多錢少都可以放生，正因為簡單易行，人人可為，太容易消業障，所以我們的冤家債主便無所不用其極，千方百計阻撓我們放生，不讓我們消業障，所以放生所遭受的阻撓最大，所引起的批評最多；這是因為眾生業障深重的緣故。因為業障深重，眾生物命無福值遇善人受救免除死難，因為業障深重，人們無福救贖生命，償還殺債。」

「批評毀謗放生，阻撓質疑放生的人要小心，因為阻撓人家放生就等於殺生，害了千千萬萬物命無法受救，含冤而死，其罪過無量無邊，一定要趕快改過懺悔，否則地獄苦刑是一定逃不掉的。」</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "master-teachings",
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>